import apiFetch from 'common/services/apiFetch';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';
import { InstanceBranding, InstanceProfile } from '../types/types';

const FALLBACK_LOGO = `${process.env.PUBLIC_URL || ''}/logo512.png`;

function isProfile(value: string): value is InstanceProfile {
	return (
		value === 'production' || value === 'staging' || value === 'development'
	);
}

/**
 * Lecture publique, sans jeton.
 * redirectOn401 est coupé : une API pas encore à jour répond 401,
 * et la redirection habituelle chasserait l'utilisateur de la connexion.
 */
export async function fetchInstanceBranding(): Promise<InstanceBranding | null> {
	const base = getApiBaseUrl();
	if (!base) return null;

	try {
		const res = await apiFetch(`${base}/v2/public/branding`, undefined, {
			redirectOn401: false,
		});
		if (!res.ok) {
			console.error('Identité instance HTTP', res.status);
			return null;
		}
		const body: unknown = await res.json();
		if (
			typeof body !== 'object' ||
			body === null ||
			!('displayName' in body) ||
			!('profile' in body) ||
			!('hasLogo' in body)
		) {
			console.error('Identité instance illisible', body);
			return null;
		}
		const displayName =
			typeof body.displayName === 'string' ? body.displayName : '';
		const profile =
			typeof body.profile === 'string' && isProfile(body.profile)
				? body.profile
				: 'staging';
		const hasLogo = body.hasLogo === true;
		const logoRevision =
			'logoRevision' in body && typeof body.logoRevision === 'number'
				? body.logoRevision
				: null;
		return { displayName, profile, hasLogo, logoRevision };
	} catch (error) {
		console.error(error);
		return null;
	}
}

export function instanceLogoUrl(branding: InstanceBranding | null): string {
	if (!branding?.hasLogo || branding.logoRevision === null) {
		return FALLBACK_LOGO;
	}
	const base = getApiBaseUrl();
	if (!base) return FALLBACK_LOGO;
	return `${base}/v2/public/logo?v=${branding.logoRevision}`;
}

export async function uploadInstanceLogo(
	token: string,
	file: File
): Promise<void> {
	const body = new FormData();
	body.append('logo', file);
	await apiFetch(`${getApiBaseUrl()}/v2/instance/logo`, {
		method: 'POST',
		headers: { Authorization: `Bearer ${token}` },
		body,
	});
}

export async function deleteInstanceLogo(token: string): Promise<void> {
	await apiFetch(`${getApiBaseUrl()}/v2/instance/logo`, {
		method: 'DELETE',
		headers: { Authorization: `Bearer ${token}` },
	});
}
